<script setup>
import Button from "@/Components/Button.vue";
import { ArrowDownTrayIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
    track: Object,
    user_order: Object | null,
});

function myAlert() {
    alert("You need to purchase this track first before accessing it.");
}
</script>

<template>
    <span v-if="$page.props.user && $page.props.user.id === 1">
        <span v-if="track.pricing === 'paid' && user_order === null">
            <Button
                class="h-6 disabled:opacity-50"
                hint="You need to pay for this track first."
                @click="myAlert()"
                >Download
            </Button></span
        >
        <span v-else>
            <Button
                target="_blank"
                class="h-6"
                :href="route('open_rbr_app', { fill_track_pin: track.pin })"
                ><ArrowDownTrayIcon
                    class="-ml-0.5 mr-1.5 size-4"
                    aria-hidden="true"
                />Download
            </Button>
        </span>
    </span>
</template>
